<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!displayConfirmForm) {
  <div class="content-container">
    <div>
      <div class="title d-inline-flex w-100">
        <mwp-text-translate text="MEMBER CREATION FORM" jsonKey="memberCreationForm" />
      </div>
      <div class="content">
        @if (companies) {
        <div class="col-6">
          <mat-form-field appearance="outline">
            <mat-label>
              <mwp-text-translate text="Select a Company" jsonKey="selectACompany" />
            </mat-label>
            <mat-select [(value)]="selectedCompanyId">
              @for (company of companies; track company) {
              <mat-option [value]="company.companyID" (onSelectionChange)="companyChange($event)">
                {{company.companyName}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
    </div>
    @if (displayForm) {
    <div>
      <mwp-member-create-form [agentCreateMemberModel]="agentCreateMemberModel" (emitSave)="createMember($event)">
      </mwp-member-create-form>
    </div>
    }
  </div>
  }
  @if (displayConfirmForm) {
  <div>
    <mwp-member-confirm [member]="memberSearchResult" (emitBack)="back()"></mwp-member-confirm>
  </div>
  }